import React, { useCallback } from "react";

import "./EmptyOrder.css";
import { useNavigate } from "react-router-dom";
import Icons from "../../../../../../Config/Images";

const EmptyOrder = () => {
  const navigate = useNavigate();

  const handleButtonNavigation = useCallback(() => {
    navigate("/home"); // Navigate to the homepage or another page if needed
  }, [navigate]);

  return (
    <>
      <div className="EmptyOrderDiv">
        <div className="text-content">
          <h3>Your orders are empty.</h3>
          <p>Start shopping now to fill your orders with amazing jewellery!</p>
        </div>
        <img src={Icons.emptyCartImage} alt="Empty Orders" />
        <div className="button-shopping">
          <button onClick={handleButtonNavigation}>Explore now</button>
        </div>
      </div>
    </>
  );
};

export default EmptyOrder;
